class ImplantationCarte {
  constructor(){
    if(jQuery('main').hasClass('tpl-presentation-carte')) {
      this.cartePrincipal = jQuery('#js--implantation-carteGlobal');
      this.carteSecondaire = jQuery('.recherche-entreprise-resultat__carte');
      this._init();
    }
  }

  _init(){
    document.addEventListener('DOMContentLoaded', (event) => {
      if(this.cartePrincipal){
        var departementCarte = this.cartePrincipal.attr('liste_departement').split(',');
        for(const departement of departementCarte){
          if(departement !== ''){
            this.cartePrincipal.find('path.'+departement).attr('fill','#FBB131');
          }
        }
      }

      if(this.carteSecondaire){
        this.carteSecondaire.map(function(){
          var departementCarte = jQuery(this).attr('liste_departement').split(',');
          for(const departement of departementCarte){
            if(departement !== ''){
              jQuery(this).find('path.'+departement).attr('fill','#FBB131');
            }
          }
        });
      }
    });
  }
}

export const implantationCarte = new ImplantationCarte();